import { Lockup } from './Lockup';

export function ComingSoon() {
  return (
    <article className="flex flex-col items-center gap-8">
      <Lockup />

      <p className="font-mono text-bloudraad-blue-light dark:text-bloudraad-spark text-xs uppercase tracking-[0.2em]">
        <span aria-hidden="true">◆ </span>
        coming soon
      </p>

      <h1 className="font-display text-4xl font-extrabold leading-tight sm:text-5xl md:text-6xl">
        <span className="block">Something&apos;s</span>
        <span className="block text-bloudraad-blue-light dark:text-bloudraad-blue">printing.</span>
      </h1>

      <p className="max-w-prose text-lg leading-relaxed text-bloudraad-light-text-secondary dark:text-bloudraad-dark-text-secondary">
        World-class HTML &amp; CSS to PDF rendering. The press is warming up — check back soon.
      </p>

      <a
        href="mailto:hello@bloudraad.io"
        className="btn btn-primary no-underline"
      >
        Get in touch
      </a>
    </article>
  );
}
